document.querySelectorAll( '.b-lottie' ).forEach( ( block ) => {

	const players = block.querySelectorAll( 'dotlottie-player' );

	if ( players.length === 0 ) {

		return;

	}

	/**
	 * Loads the source of a player element and removes its placeholder when the player is ready.
	 *
	 * @param {HTMLElement} player - The player element to load the source for.
	 */
	const loadASrc = async ( player ) => {

		const src = player.dataset.src;
		if ( ! src ) {

			return;

		}

		/**
		 * Normalizes the animation data by ensuring it has the required structure.
		 *
		 * @param {Object} animationData
		 * @return {Object}
		 */
		const normalizeAnimationData = ( animationData ) => {

			if ( ! animationData || typeof animationData !== 'object' || Array.isArray( animationData ) ) {

				return animationData;

			}

			if ( ! Array.isArray( animationData.assets ) ) {

				animationData.assets = [];

			}

			if ( ! Array.isArray( animationData.layers ) ) {

				animationData.layers = [];

			}

			return animationData;

		};

		let loaded = false;

		try {

			const response = await fetch( src, {
				credentials: 'same-origin',
			} );

			if ( response.ok ) {

				const raw = await response.text();
				const trimmed = raw.trim();

				if ( trimmed.startsWith( '{' ) || trimmed.startsWith( '[' ) ) {

					const animationData = normalizeAnimationData( JSON.parse( trimmed ) );
					await player.load( animationData );
					loaded = true;

				}

			}

		} catch ( error ) {
			// Fall back to URL-based loading when parsing fails.
		}

		if ( ! loaded ) {

			await player.load( src );

		}

		const placeholder = player.parentElement.querySelector( '.b-lottie__placeholder' );

		if ( placeholder ) {

			placeholder.remove();

		}

	};

	players.forEach( ( player ) => {

		const trigger = player.dataset.trigger;
		const isMobile = window.matchMedia( '(max-width: 991px)' ).matches;

		const playObserver = new IntersectionObserver( ( entries, obs ) => {

			entries.forEach( ( entry ) => {

				if ( entry.isIntersecting ) {

					const overlay = block.querySelector( '.js-animation-tooltips-overlay' );

					player.setAttribute( 'autoplay', 'true' );
					player.play();

					if ( overlay ) {

						overlay.classList.add( 'is-visible' );

					}

					player.addEventListener( 'complete', () => {

						obs.unobserve( entry.target );

					} );

				}

			} );

		}, {
			threshold: isMobile ? 0 : 0.9,
			rootMargin: isMobile ? '-30%' : '0px',
		} );

		const loadingObserver = new IntersectionObserver( ( entries, obs ) => {

			entries.forEach( ( entry ) => {

				if ( entry.isIntersecting ) {

					void ( async () => {

						await loadASrc( player );

						if ( window.matchMedia( '(max-width: 991px)' ).matches || trigger === 'scroll' ) {

							playObserver.observe( player );

						}

						obs.unobserve( entry.target );

					} )();

				}

			} );

		}, {
			threshold: 0.1,
		} );

		loadingObserver.observe( player );

		if ( trigger === 'hover' ) {

			const hoverEndAction = player.dataset.hoverEnd;
			const playerParent = player.closest( '.b-animation__box' );
			const hoverElement = playerParent ? playerParent : player;

			if ( window.matchMedia( '(max-width: 991px)' ).matches ) {

				return;

			}

			hoverElement.addEventListener( 'mouseenter', () => {

				player.setDirection( 1 );
				player.play();

			} );

			hoverElement.addEventListener( 'mouseleave', () => {

				if ( hoverEndAction === 'stop' ) {

					player.stop();

				} else if ( hoverEndAction === 'pause' ) {

					player.pause();

				} else if ( hoverEndAction === 'rewind' ) {

					player.setDirection( -1 );
					player.play();

				}

			} );

		}

	} );

} );
